"use client"

import { useState } from "react"
import Link from "next/link"
import { Menu, X } from "lucide-react"
import { Button } from "@/components/ui/button"
import { EarlyAccessDialog } from "./early-access-dialog"

export function LandingNavigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [showEarlyAccess, setShowEarlyAccess] = useState(false)

  return (
    <>
      <nav className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <Link href="/" className="flex items-center">
              <img src="/Revvu-Logo-Light.svg" alt="revvu logo" className="h-8 w-auto" />
              <span className="ml-2 px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full">
                Coming Soon
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <Link href="/" className="text-gray-600 hover:text-gray-900 transition-colors">
                Features
              </Link>
              <Link href="/pricing" className="text-gray-600 hover:text-gray-900 transition-colors">
                Pricing
              </Link>
              <Button variant="outline" onClick={() => setShowEarlyAccess(true)}>
                Join Early Access
              </Button>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-600 hover:text-gray-900 focus:outline-none"
              >
                {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-100">
              <div className="flex flex-col space-y-4">
                <Link
                  href="/"
                  className="text-gray-600 hover:text-gray-900 transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Features
                </Link>
                <Link
                  href="/pricing"
                  className="text-gray-600 hover:text-gray-900 transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Pricing
                </Link>
                <Button
                  className="bg-green-600 hover:bg-green-700 text-white w-full"
                  onClick={() => {
                    setIsMenuOpen(false)
                    setShowEarlyAccess(true)
                  }}
                >
                  Join Early Access
                </Button>
              </div>
            </div>
          )}
        </div>
      </nav>

      <EarlyAccessDialog open={showEarlyAccess} onOpenChange={setShowEarlyAccess} />
    </>
  )
}
